import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeModule, MatTreeNestedDataSource } from '@angular/material/tree';
import { Router, NavigationEnd, RouterModule, Scroll } from '@angular/router';
import { filter } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectDealerMenuData } from 'src/app/common/store/state/app.state';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { TransactionStage } from 'src/app/public/common/constants/common-basic-data';
import { MenuCode, SessionBasicData } from 'src/app/public/common/constants/session-basic-data';

export interface MenuNode {
  code: MenuCode,
  title: string;
  noQuantity?: boolean;
  link?: string;
  quantity?: number;
  children?: MenuNode[];
  parent?: MenuNode;
  transactionStages?: TransactionStage[];
}

@Component({
    selector: 'app-dealer-menu',
    imports: [RouterModule, MatTreeModule, MatIconModule, MatButtonModule],
    templateUrl: './dealer-menu.component.html',
    styleUrl: './dealer-menu.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    animations: [
        trigger('expandCollapse', [
            state('collapsed', style({ height: '0px', overflow: 'hidden', opacity: 0 })),
            state('expanded', style({ height: '*', overflow: 'hidden', opacity: 1 })),
            transition('collapsed <=> expanded', animate('200ms ease-in-out')),
        ])
    ]
})
export class DealerMenuComponent implements OnInit {
  treeControl = new NestedTreeControl<MenuNode>(node => node.children);
  dataSource = new MatTreeNestedDataSource<MenuNode>();
  currentRoute: string = '';

  //currentNodeCode: MenuCode = MenuCode.ACCOUNT;

  menuData$: Observable<{[key: string]: number}>;
  menuData: {[key: string]: number} = {};

  tes: any

  constructor( 
    //private menuData: SessionService,
    private store: Store, 
    private router: Router) {

      this.menuData$ = store.select(selectDealerMenuData);

      this.menuData$.subscribe(
        (result: any)  => {
          this.menuData = result;
        }
      )
  }

  ngOnInit() {
    //this.menuData$ = this.store.select(selectDealerMenuData);

    this.dataSource.data = SessionBasicData.sessionMenu;
    this.setParents(this.dataSource.data);

    this.menuData$.subscribe(
        (result: any)  => {
          this.menuData = result;
          this.refreshQuantities();
        }
      )

    this.refreshQuantities();

    this.router.events
      //.pipe(filter(event => event instanceof NavigationEnd))
      //.pipe(filter(event => ! (event instanceof Scroll)))
      .subscribe((event: any) => {
        //this.currentRoute = event.urlAfterRedirects;
        //this.currentRoute = event.routerEvent.url;
        //this.currentRoute = this.router.url.toString()
        
        //this.tes = event.constructor.name
        //if(this.currentRoute !== this.router.url.toString() ){
        if(event.routerEvent){
          //console.log(event.routerEvent)
          this.currentRoute = event.routerEvent.url;
          this.refreshQuantities();
          this.dataSource.data.forEach(node => this.expandActiveRoute(node));
          this.dataSource.data.forEach(node => this.collapseInactiveBranches(node));
        }
        
      });
  }

  private refreshQuantities() {
    this.dataSource.data.forEach(node => this.loadQuantities(node));
    this.dataSource.data.forEach(node => this.calculateQuantity(node));
  }
  /*
  private loadQuantitiesOld(node: MenuNode) {
    if (node.code) {
      this.menuData.getItemCount(node.code).subscribe(count => {
        node.quantity = count;
        this.calculateQuantity(node);
      });
    }
    node.children?.forEach(child => this.loadQuantities(child));
  }
    */

  private loadQuantities(node: MenuNode) {
    if (node.code) {
        node.quantity = this.menuData == undefined ? 0 : this.menuData[node.code.toString()];
        this.calculateQuantity(node);
    }
    node.children?.forEach(child => this.loadQuantities(child));
  }

  private calculateQuantity(node: MenuNode): number {
    if (!node.children || node.children.length === 0) return node.quantity ?? 0;
    const total = node.children.map(child => this.calculateQuantity(child)).reduce((a, b) => a + b, 0);
    node.quantity = total;
    return total;
  }

  hasChild = (_: number, node: MenuNode) => !!node.children && node.children.length > 0;

  // Auto-expand active path
  private expandActiveRoute(node: MenuNode) {
    
    if (node.children) {
      for (let child of node.children) {
        if (child.link === this.currentRoute || this.containsRoute(child, this.currentRoute)) {

          this.fetchNodeData(node);

          this.treeControl.expand(node);
          this.expandActiveRoute(child);
        }
      }
    }
  }
  /*
  private expandActiveRoute(node: MenuNode) {
    if (node.children) {
      for (let child of node.children) {
        if (child.link === this.currentRoute || this.containsRoute(child, this.currentNodeCode)) {
          this.treeControl.expand(node);
          this.expandActiveRoute(child);
        }
      }
    }
  }
  */

  // Auto-collapse inactive branches
  private collapseInactiveBranches(node: MenuNode) {

    if (node.children) {
      for (let child of node.children) {
        if (!this.containsRoute(child, this.currentRoute)) {
          this.treeControl.collapse(child);
        }
        this.collapseInactiveBranches(child);
      }
    }
  }
  /*
  private collapseInactiveBranchesNew(node: MenuNode) {
    if (node.children) {
      for (let child of node.children) {
        if (!this.containsRoute(child, this.currentNodeCode)) {
          this.treeControl.collapse(child);
        }
        this.collapseInactiveBranches(child);
      }
    }
  }
  */
  
  private containsRoute(node: MenuNode, route: string): boolean {
    if (node.link === route) return true;
    return node.children?.some(child => this.containsRoute(child, route)) ?? false;
  }
  /*
  private containsRouteNew(node: MenuNode, currentNodeCode: MenuCode): boolean {
    if (node.code === currentNodeCode) return true;
    return node.children?.some(child => this.containsRoute(child, currentNodeCode)) ?? false;
  }
  */

  fetchNodeData(node: MenuNode){

    if(this.treeControl.isExpanded(node))
      return

    let codes: MenuCode[] = [node.code]

    if (node.children){
      node.children.forEach( (child) => codes.push(child.code))
    }

    this.store.dispatch(DealerActions.menuFetchSubmit({ codes: codes}) );
  }

  private setParents(nodes: MenuNode[], parent: MenuNode | undefined = undefined): void {
    nodes.forEach(node => {
      node.parent = parent;
      if (node.children && node.children.length > 0) {
        this.setParents(node.children, node);
      }
    });
  }
}
